<template>
<!-- <div class="sidebar-header"></div> -->
</template>
<script>
export default {
  name: 'sidebar-header'
}
</script>



// WEBPACK FOOTER //
// SidebarHeader.vue?1304a51c